import { z } from 'zod';
export const aiContentPageSize = 10;
export const aiContentSearchSchema = z.object({
  aiQ: z.string().trim().max(200).optional(),
  aiPage: z.coerce.number().int().min(1).max(100000).optional(),
});
export type AiContentSearch = z.infer<typeof aiContentSearchSchema>;
